import TopBar from '../top-header';
import ProgramList from "../program-list"
import { useState,useRef } from 'react';

function App(){
    const [starterSettings,SetStarterSettings] = useState({heading:"Two Ton Games v2.0.0", subheading:"Two friends. One goal. No skills.",backgroundColor:"#008989"});
    const [seizureModeActivated,SetSeizureModeActivated] = useState(false);
    const seizureRef = useRef(null);  // useRef to hold the interval ID
    const changeColors = (colorToChange,isPartOfSeizureMode) => {
        if(!isPartOfSeizureMode){
            window.clearInterval(seizureRef.current);
        }
        let newSettings = {...starterSettings, backgroundColor: colorToChange};
        document.body.style.backgroundColor = colorToChange;
        document.getElementById("theme-color").setAttribute("content",colorToChange);
        SetStarterSettings(newSettings);
    }
    const activateSeizureMode = () =>{ 
        if (!seizureModeActivated) {
            seizureRef.current = window.setInterval(() => {
                const randomColor = Math.floor(Math.random() * 16777216);
                const hexColor = '#' + randomColor.toString(16).padStart(6, '0');
                changeColors(hexColor,true);
            }, 1000);
        } else {
            if (seizureRef.current) {
                window.clearInterval(seizureRef.current);
            }
    }
    SetSeizureModeActivated(prevMode => !prevMode);
}
    const changeHeader = (name, subtitle) => {
        let nameToChangeTo = name;
        let subtitleToChange = subtitle;
        if(!nameToChangeTo){nameToChangeTo = starterSettings.heading}
        if(!subtitleToChange){subtitleToChange = starterSettings.subheading};
        let newSettings = {...starterSettings, heading: nameToChangeTo,subheading:subtitleToChange};
        SetStarterSettings(newSettings);
    }
    const resetSettings = (previousStuff) => {
        SetSeizureModeActivated(false);
        window.clearInterval(seizureRef.current);
        document.body.style.backgroundColor = previousStuff.backgroundColor;
        document.getElementById("theme-color").setAttribute("content",previousStuff.backgroundColor);
        SetStarterSettings(previousStuff);
    }
    return <>
    <TopBar text={starterSettings.heading} subheading={starterSettings.subheading} color={starterSettings.backgroundColor}></TopBar>
    <ProgramList seizureModeFunction={activateSeizureMode} resetSettings={resetSettings} color={starterSettings.backgroundColor} changeColorFunction={changeColors} changeHeaderFunction={changeHeader} previousStatePass={starterSettings}></ProgramList>
    </>
}
export default App